import clsx from "clsx";
import { useTranslation } from "react-i18next";
import InternalPageLayout from "../../layouts/InternalPage/InternalPageLayout";

const TermsAndConditionsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <InternalPageLayout
      title={t("Términos y Condiciones de Uso")}
      description={t("Términos y Condiciones de Uso de eXpenser.net")}
    >
      <div
        className={clsx([
          "flex",
          "w-full",
          "flex-col",
          "gap-6",
          "text-sm md:text-base",
        ])}
      >
        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            1. Aceptación de los términos
          </h2>
          <p>
            Al acceder y utilizar la aplicación <strong>eXpenser.net</strong>{" "}
            (en adelante, "la aplicación"), aceptas cumplir con estos Términos y
            Condiciones de Uso. Si no estás de acuerdo con estos términos, no
            utilices la aplicación.
          </p>
        </div>
        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            2. Descripción del servicio
          </h2>
          <p>
            <strong>eXpenser.net</strong> es una aplicación diseñada para ayudar
            a los usuarios a gestionar sus ingresos y gastos, proporcionando
            herramientas para un mejor control financiero.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            3. Uso permitido
          </h2>
          <p>
            Como usuario, te comprometes a utilizar la aplicación únicamente
            para fines legales y de acuerdo con estos términos. No debes:
          </p>
          <ul className="list-disc ml-8 ">
            <li>
              Usar la aplicación para actividades ilícitas, fraudulentas o no
              autorizadas.
            </li>
            <li>
              Intentar acceder sin autorización a sistemas, datos o información
              de otros usuarios.
            </li>
            <li>
              Distribuir virus, malware o cualquier código dañino a través de la
              aplicación.
            </li>
            <li>
              Interferir con el funcionamiento normal de la aplicación o
              intentar deshabilitar sus medidas de seguridad.
            </li>
          </ul>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            4. Propiedad intelectual
          </h2>
          <p>
            Todo el contenido de la aplicación, incluyendo el diseño, texto,
            gráficos, logotipos, imágenes y código, es propiedad de
            <strong>eXpenser.net</strong> o de sus licenciantes y está protegido
            por las leyes de propiedad intelectual aplicables.
          </p>
          <p>
            No se permite reproducir, distribuir, modificar o usar cualquier
            parte de la aplicación sin el permiso expreso del propietario.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            5. Limitación de responsabilidad
          </h2>
          <p>
            <strong>eXpenser.net</strong> se proporciona "tal cual" y no
            garantiza que la aplicación esté libre de errores, sea completamente
            segura o esté disponible de forma ininterrumpida. El uso de la
            aplicación es bajo tu propio riesgo.
          </p>
          <p>
            <strong>eXpenser.net</strong> no será responsable de ningún daño
            directo, indirecto, incidental o consecuente derivado del uso o la
            imposibilidad de uso de la aplicación.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            6. Modificaciones a los términos
          </h2>

          <p>
            Nos reservamos el derecho de modificar estos Términos y Condiciones
            en cualquier momento. Te notificaremos sobre cambios importantes
            publicando los términos actualizados en la aplicación. Es tu
            responsabilidad revisar periódicamente estos términos.
          </p>
          <p>
            Si continúas utilizando la aplicación después de que los términos
            hayan sido actualizados, se considerará que aceptas las
            modificaciones.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            7. Retención de datos
          </h2>
          <p>
            Retendremos tus datos durante el tiempo que sea necesario para
            cumplir con los fines establecidos en esta política o hasta que
            elimines tu cuenta.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            8. Cambios en esta Política de Privacidad
          </h2>
          <p>
            Nos reservamos el derecho de modificar esta Política de Privacidad
            en cualquier momento. Te notificaremos sobre cualquier cambio
            mediante la publicación de la nueva política en nuestra aplicación.
            La fecha de la última actualización se reflejará en la parte
            superior de esta página.
          </p>
          <p>
            Te recomendamos que revises periódicamente esta Política de
            Privacidad para estar informado sobre cómo estamos protegiendo tu
            información.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            9. Cancelación del acceso
          </h2>
          <p>
            Podemos suspender o cancelar tu acceso a la aplicación en cualquier
            momento si determinamos que has violado estos términos o por
            cualquier otra razón a nuestra discreción. También puedes cerrar tu
            cuenta en cualquier momento si ya no deseas utilizar la aplicación.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            10. Ley aplicable
          </h2>
          <p>
            Estos Términos y Condiciones se regirán e interpretarán de acuerdo
            con las leyes de Costa Rica. Cualquier disputa que surja en relación
            con la aplicación será resuelta exclusivamente en los tribunales de
            Costa Rica.
          </p>
        </div>

        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <h2 className={clsx(["text-lg", "md:text-xl", "font-medium"])}>
            11. Contacto
          </h2>
          <p>
            Si tienes preguntas o inquietudes sobre estos Términos y
            Condiciones, puedes ponerte en contacto con nosotros:
          </p>
          <ul className="list-disc ml-8 ">
            <li>
              <strong>Correo electrónico:</strong>{" "}
              <a
                href="mailto:dev@calirojas.com"
                className="text-black dark:text-white underline"
              >
                dev@calirojas.com
              </a>
            </li>
            <li>
              <strong>Dirección:</strong> San José, Costa Rica
            </li>
          </ul>
        </div>
      </div>
    </InternalPageLayout>
  );
};

export default TermsAndConditionsPage;
